import { getCampaignCountries, getCampaignPriceMessages } from 'store/campaign/campaignSelectors';
import { getCountry as getSearchCountry } from 'store/search/searchSelectors';
import { getCountry as getPropertyCountry } from 'store/property/propertySelectors';
import { useSelector } from 'react-redux';
import { DEFAULT_CAMPAIGN } from 'config';

const caseInsensitiveIncludes = (array, string) => array.some((item) => item.toLowerCase() === string.toLowerCase());

export default function useCampaignPriceMessage({ currency, fallback = false }) {
  const searchCountry = useSelector(getSearchCountry);
  const propertyCountry = useSelector(getPropertyCountry);
  const country = searchCountry || propertyCountry;

  const isCurrencyPoints = currency === 'PTS';
  const campaignPriceMessages = useSelector(getCampaignPriceMessages);
  const { include: includedCountries = [], exclude: excludedCountries = [] } = useSelector(getCampaignCountries) || {};

  const message = isCurrencyPoints ? campaignPriceMessages?.points : campaignPriceMessages?.cash;
  const defaultMessages = DEFAULT_CAMPAIGN?.messages?.priceMessages;
  const campaignPriceMessage = message || (fallback && isCurrencyPoints ? defaultMessages?.points : defaultMessages?.cash);
  const showCampaignPriceMessage =
    campaignPriceMessage &&
    (includedCountries.length === 0 || caseInsensitiveIncludes(includedCountries, country)) &&
    (excludedCountries.length === 0 || !caseInsensitiveIncludes(excludedCountries, country));

  return { showCampaignPriceMessage, campaignPriceMessage };
}
